<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p3.jpg"
              width="100%"
              alt="Blueshark R1 high-speed electric motor"
            />
          </div>
          <div class="text t3">
            <div class="fs_big1 fw_bold t3_1 aniel" :class="{ ani: a1 }">
              Power Your Ride
            </div>
            <div class="fs_sub color_gray t3_2 aniel" :class="{ ani1: a1 }">
              5,000 W High-speed Electric Motor
            </div>
            <div class="fs_tiny aniel" :class="{ ani2: a1 }">
              R for “Robor.” The Blueshark R1 is powered by a cutting-edge
              permanent magnet gear motor, with performance that far surpasses
              that of any typical wheel hub motor.<br />Be prepared for an
              adrenaline rush when you start your ride!
            </div>
          </div>
          <div class="text t3a">
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">5,000</span>
                <span class="fs_tiny">w</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }"
                >Maximum Power</span
              >
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">5,500</span>
                <span class="fs_tiny">rpm</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }"
                >Maximum RPM</span
              >
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">201</span>
                <span class="fs_tiny">N·m</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }"
                >Torque</span
              >
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">80</span>
                <span class="fs_tiny">km/h</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }"
                >Top Speed</span
              >
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">40</span>
                <span class="fs_tiny">%</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }"
                >Climbing Ability</span
              >
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }"
                ><span class="fs_big">4.9</span>
                <span class="fs_tiny">s</span></span
              ><br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }"
                >From 0-50 kmph</span
              >
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img src="/static/img/p3-2.jpg" width="100%" alt="" />
          </div>
          <div class="text t3">
            <div class="title fs_middle fw_bold">Gear Drive</div>
            <div class="fs_tiny">
              Compared to a traditional belt and chain drivetrain, the Blueshark
              R1’s 20CrMnTi alloy gear set has clear advantages in regards to<br />transmission
              rate, efficiency and life expectancy.
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      a1: false,
      a2: false,
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    startani1() {
      this.a1 = true
    },
    startani2() {
      this.a2 = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t3 {
  top: 3vw;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  .t3_1 {
    margin-bottom: 10px;
  }
  .t3_2 {
    margin-bottom: 20px;
  }
}
.t3a {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  left: 20vw;
  bottom: 10vw;
  right: 20vw;
  text-align: center;
}

.aniel {
  position: relative;
  opacity: 0;
}
.ani {
  animation: tani 1s forwards;
}
.ani1 {
  animation: tani 1s forwards 0.1s;
}
.ani2 {
  animation: tani 1s forwards 0.2s;
}

@keyframes tani {
  from {
    top: 60px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_en/swiper3.vue